export default import.meta.ROLLDOWN_FILE_URL_MOKOl7mOPJYpSTW2nyk4zA